import { ImageComponent } from '@/components/Image';
import {
  ScContentWrapper,
  ScHeaderBadge,
  ScHeaderCell,
  ScHeaderLevelLabel,
  ScHeaderSubTitle,
  ScHeaderTextBlock,
  ScHeaderTitle,
} from '@/modules/vip/ComparisonSection/components/ComparisonTable/styled';
import type { IComparisonUICol } from '@/modules/vip/ComparisonSection/types';

export const ColHeaderCell = ({
  col,
  index,
}: {
  col: IComparisonUICol;
  index: number;
}) => (
  <ScHeaderCell $colIndex={index}>
    <ScHeaderTextBlock>
      <ScContentWrapper>
        <ScHeaderTitle>{col.title}</ScHeaderTitle>
        <ScHeaderSubTitle>{col.subTitle}</ScHeaderSubTitle>
      </ScContentWrapper>
      {col.levelLabel && (
        <ScHeaderLevelLabel>{col.levelLabel}</ScHeaderLevelLabel>
      )}
    </ScHeaderTextBlock>
    {col.badgeUrl && (
      <ScHeaderBadge>
        <ImageComponent
          alt={col.title}
          className="badge-img"
          height={120}
          src={col.badgeUrl}
          width={120}
        />
      </ScHeaderBadge>
    )}
  </ScHeaderCell>
);
